import React from "react";
import Marquee from "react-fast-marquee";
import { useLang, pick } from "../context/LanguageContext";

export const MarqueeStrip = ({ settings }) => {
  const { lang } = useLang();
  const phrase = pick(settings?.tagline, lang);
  const items = [phrase, "Tacos", "Quesabirria", "Pupusas", "Burritos", "Fresh Daily"];

  return (
    <div className="border-y border-brand-line bg-brand-primary/95 py-5 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-4xl px-8 whitespace-nowrap text-brand-text">
              {it}
            </span>
            <span className="text-brand-gold text-2xl sm:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
